export default __webpack_public_path__ + "static/media/donati-banner-tablet.5bc2232d.jpg";